export const DEFAULT_CONTENT = {
  brand: {
    logo: "",
  },
  hero: {
    eyebrow: "Molarapatti · Tiruppur District · Tamil Nadu",
    tamil: "அங்கு குமரன் பண்ணை இல்லம்",
    titleLine1: "A traditional farmhouse,",
    titleAccent: "modern",
    titleRest: " at heart.",
    subline:
      "A private estate for family weekends and get-togethers, corporate meetings and stays, birthdays and celebrations, and film & ad film shoots — set among coconut palms and open skies.",
    image: "https://images.unsplash.com/photo-1721989519334-40923a0ee1c0?auto=format&fit=crop&w=1400&q=80",
  },
  marquee: {
    items: [
      { text: "Family Weekend Stays" },
      { text: "Get-Togethers" },
      { text: "Corporate Meetings & Stays" },
      { text: "Birthdays & Celebrations" },
      { text: "Film & TV Series Shooting" },
      { text: "Ad Film Shooting" },
    ],
  },
  about: {
    eyebrow: "About the Estate",
    title: "Rooted in Tamil tradition, built for modern gathering.",
    lead:
      "Angukumaran Farmhouse is a traditional Tamil Nadu farmhouse with modern facilities — a private estate where coconut palms, open lawns and airy verandahs set the pace for unhurried time together.",
    body:
      "Families gather here for slow weekends and milestones, teams step away for focused offsites, and film crews find authentic rural backdrops with contemporary comfort. Every stay is the whole estate to yourself.",
    cards: [
      {
        tag: "Staycations",
        title: "Family Weekend Stays & Get-Togethers",
        desc: "Unplug from city chaos in a private, lush green sanctuary built for multigenerational comfort.",
        icon: "Users",
        image: "https://images.unsplash.com/photo-1776762893034-c437e452f1be?auto=format&fit=crop&w=1200&q=80",
      },
      {
        tag: "Corporate",
        title: "Corporate Meetings & Offsites",
        desc: "Inspiring indoor & outdoor spaces surrounded by nature, made for strategy and team bonding.",
        icon: "Users",
        image: "",
      },
      {
        tag: "Celebrations",
        title: "Birthdays & Family Celebrations",
        desc: "Spacious lawns, dining pavilions and poolside backdrops for life's finest milestones.",
        icon: "Cake",
        image: "",
      },
      {
        tag: "Shoots",
        title: "Film & TV Series Shooting",
        desc: "Authentic rural Tamil Nadu architecture with modern amenities and rich cinematic angles.",
        icon: "Clapperboard",
        image: "",
      },
      {
        tag: "Production",
        title: "Ad Film & Commercial Shoots",
        desc: "A controlled private estate with natural sunlight and zero disturbance.",
        icon: "Video",
        image: "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?auto=format&fit=crop&w=1200&q=80",
      },
    ],
  },
  facilities: {
    eyebrow: "Facilities",
    title: "Everything the countryside should feel like — with nothing left out.",
    lead: "Traditional warmth outside, modern convenience inside. Every facility below is part of the private estate experience.",
    items: [
      { name: "Private Swimming Pool", desc: "Crystal-clear pool with a kids' area, surrounding sunbeds and evening mood lighting." },
      { name: "Lush Coconut Plantation Lawn", desc: "Expansive manicured lawn for gatherings, games and outdoor dining under the palms." },
      { name: "Traditional Courtyard & Verandah", desc: "Airy thinnai-style seating that captures gentle breezes with authentic heritage craft." },
      { name: "Modern AC Suites & Bedrooms", desc: "Plush bedding, climate control and attached modern baths for restful nights." },
      { name: "Fully Equipped Kitchen & Dining", desc: "Modern kitchen, barbecue grill option and indoor / outdoor dining tables." },
      { name: "Campfire & Barbecue Area", desc: "A dedicated firepit under starry night skies — storytelling, music and grilling." },
      { name: "High-Speed Wi-Fi & Power Backup", desc: "Uninterrupted connectivity for remote work, screenings and corporate sessions." },
      { name: "Secure Gated Estate Parking", desc: "Ample space for private cars, guest vans and production unit vehicles." },
    ],
  },
  gallery: {
    eyebrow: "Gallery",
    title: "Scenes from the estate.",
    lead: "Lawns, pools, verandahs and lamp-lit dinners — a glimpse of the estate's moods through the day.",
    images: [
      { src: "https://images.unsplash.com/photo-1780287857946-c02092f354ba?auto=format&fit=crop&w=1400&q=80", caption: "The Estate Lawn" },
      { src: "https://images.unsplash.com/photo-1721222206268-90524c1c0aaf?auto=format&fit=crop&w=900&q=80", caption: "Poolside, Midday" },
      { src: "https://images.pexels.com/photos/29293207/pexels-photo-29293207.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "Sunlit Bedrooms" },
      { src: "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?auto=format&fit=crop&w=900&q=80", caption: "Evenings by the Pool" },
      { src: "https://images.unsplash.com/photo-1636484807510-bc2ffbaf3241?auto=format&fit=crop&w=900&q=80", caption: "The Blue Corner" },
      { src: "https://images.pexels.com/photos/9843184/pexels-photo-9843184.jpeg?auto=compress&cs=tinysrgb&w=1400", caption: "Garden Dining Under Lights" },
      { src: "https://images.unsplash.com/photo-1625579002297-aeebbf69de89?auto=format&fit=crop&w=900&q=80", caption: "Restful Interiors" },
      { src: "https://images.unsplash.com/photo-1771543828500-5066e105dc8b?auto=format&fit=crop&w=900&q=80", caption: "Green Around Every Window" },
    ],
  },
  booking: {
    eyebrow: "Book Your Stay",
    title: "Tell us your dates — we'll take it from there.",
    lead: "Share a few details and our team will confirm availability and rates over call or email.",
    sideTamil: "அங்கு குமரன் பண்ணை இல்லம்",
    sideTitle: "The whole estate, reserved for you.",
    sideBody:
      "Bookings are confirmed directly by our team — no middlemen, no online payments. Your request lands straight in our inbox.",
    phone: "+91 99363 56991",
    email: "angukumaranfarmhouse@gmail.com",
    notice: "Sent to angukumaranfarmhouse@gmail.com & our bookings desk",
  },
  location: {
    eyebrow: "Location & Contact",
    title: "Find us on the Dharapuram–Poolavadi Road.",
    address:
      "#1/174, Kallivalasu,\nDharapuram Poolavadi Road,\nMolarapatti, Tiruppur District,\nTamil Nadu – 638657",
    phone: "+91 99363 56991",
    email1: "angukumaranfarmhouse@gmail.com",
    email2: "info.akfarmhouse@gmail.com",
    mapsUrl: "https://maps.app.goo.gl/Jj7YAcKEUaR6J8Vx6",
    mapQuery: "10.776739,77.398255",
  },
  footer: {
    tagline:
      "A traditional Tamil Nadu farmhouse with modern facilities — for family stays, corporate retreats, celebrations and film productions.",
    domain: "www.angukumaranfarmhouse.com",
  },
};

export default DEFAULT_CONTENT;
